import React from "react";
// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import Table from '../widgets/tables/Table';
import Loading from "../components/Loading";
import getInvestimenti from "../services/getInvestimenti";
import deleteInvestimento from "../services/deleteInvestimento";
import moment from "moment";
import 'moment/locale/it';

export default class Investimenti extends React.Component {

  constructor(props){
    super (props)
  
    this.state = {
        isLoading: true
    };

  }

  async reload() {
    this.setState({ isLoading: true });
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    
    this.headCells = [
      { id: 'descrizione', numeric: false, disablePadding: true, label: 'Descrizione' },
      { id: 'totale', numeric: true, disablePadding: false, label: 'Importo' },
    ];  

    moment().locale('it');
    this.investimenti = await getInvestimenti(username, token);
    var dates = [];
    let currDate = '01/01/' + moment().format('yyyy');
    let endDate = '01/01/' + moment().add(1, 'year').format('yyyy');

    while (currDate.substring(currDate.length, 6) !== endDate.substring(endDate.length, 6)) {
      let data = moment(currDate, 'DD/MM/yyyy').format('MMMM yy');
      dates.push({ id: data.replace(' ', '_'), numeric: false, disablePadding: false, label: data });
      currDate = moment(currDate, 'DD/MM/yyyy').add(1, 'month').format('DD/MM/yyyy');
    }

    this.investimenti.forEach((i, index) => {

      let rate = i.rate ? JSON.parse(i.rate) : [];
      rate.forEach(r => {
        let data = moment(r.data, 'DD/MM/yyyy').format('MMMM yy');
        if (!this.investimenti[index][data.replace(' ', '_')]) {
          let importo = r.importo + ' €';
          this.investimenti[index][data.replace(' ', '_')] = importo;
        } else {
          let imp = r.importo + ' €';
          var firstI = '';
          if (i[data.replace(' ', '_')])
            firstI = i[data.replace(' ', '_')];
          let importo = firstI + firstI ? '; ' : '' + imp;
          this.investimenti[index][data.replace(' ', '_')] = importo;
        }
      })
    });

    this.headCells = [
      ...this.headCells, 
      ...dates,
      { id: '_', numeric: true, disablePadding: false, label: '' }
    ]
    
    this.setState({ isLoading: false });
  }

  async componentDidMount(){
    await this.reload();
  }


  render () {

    if (this.state.isLoading)
        return <Loading />;

    const cookies = new Cookies();

    this.searchCols = ['name'];

    return (
      <div id={Math.random()}>
        <PageTitle title="Investimenti" button="INSERISCI NUOVO" onClick={() => {
          window.location.href = '/#/app/addInvestimento';
        }}/>

        <Table headCells={this.headCells} searchCols={this.searchCols} rows={this.investimenti}
          onEventClick={(row) => {
          cookies.set('investimento', row, { path: '/' });
          window.location.href = '/#/app/editInvestimento';
        }}

        onDelete={async (id) => {
          if (window.confirm("Sei sicuro di voler eliminare questo investimento? L'azione è irreversibile ed eliminerà anche tutte le uscite registrate per questo investimento.") === false) return;

          const cookies = new Cookies();
          const username = cookies.get('username', { path: '/' });
          const token = cookies.get('token', { path: '/' });

          await deleteInvestimento(username, token, id);
          this.reload();
        }}

        />
      </div>
    );
  }
}

